// 轮播图广告
import React from 'react'

import { useAdStat } from 'Components/ad'
import Label from '../../home/ad/label'
import { IBannerAD } from '../ad/interface'

function VideoImage({ data }: { data: IBannerAD }) {
  const { ref, handleClick } = useAdStat(
    {
      send: '',
      show: '',
      click: 'ad_click_video_top_banner',
    },
    data
  )
  return (
    <>
      <a target="_blank" className="container">
        <div
          className="ad"
          ref={ref}
          onClick={() => {
            handleClick()
            setTimeout(() => {
              window.open(data.web_url, '_blank')
            }, 50)
          }}
        >
          <div className="text">
            <h3>{data.title}</h3>
          </div>
          <Label text={data.label} />
        </div>
      </a>
      <style jsx>
        {`
          .container {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
          }
          .ad {
            width: 100%;
            height: 100%;
          }
          .text {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 30px 23px;
            font-weight: 500;
            color: #fff;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0),
              rgba(0, 0, 0, 0.5)
            );
          }
          h3 {
            margin-top: 8px;
            line-height: 42px;
            font-size: 30px;
          }
        `}
      </style>
    </>
  )
}

function VideoTitle({ result }: { result: IBannerAD }) {
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_video_top_banner',
      show: 'ad_show_video_top_banner',
      click: 'ad_click_video_top_banner',
    },
    result
  )
  return (
    <>
      <p
        ref={ref}
        className="banner_title"
        onClick={() => {
          handleClick()
          setTimeout(() => {
            window.open(result.web_url, '_blank')
          }, 50)
        }}
      >
        {result.title}
      </p>
      <style jsx>
        {`
          .banner_title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        `}
      </style>
    </>
  )
}

export { VideoImage, VideoTitle }
